"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrintableCharacter;

function isPrintableCharacter(str) {
  if (typeof str !== 'string') return false;
  return str.length === 1 && /\S/.test(str);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Tree/helpers/isPrintableCharacter.js
// module id = WE4a
// module chunks = 0